export type Row = [string, string];

export const contrastRows: Row[] = [
  ['Watched once, forgotten by the time it matters', 'Consulted at the moment it matters'],
  ['Tells you which muscle', 'Tells you what to say'],
  ['Months and thousands of dollars', 'Usable in your very next class'],
];

export const transformationRows: Row[] = [
  [
    '"Just so you know, I have a herniated disc" ends your class plan',
    "It starts a 90-second protocol you've already rehearsed",
  ],
  [
    'You say "listen to your body" and know it answered nothing',
    'You give a specific sensation to watch for and a specific option to take',
  ],
  [
    "A diagnosis you don't recognize makes you feel exposed in front of the room",
    'You ask one question that only the student can answer — and it reads as care, not ignorance',
  ],
  [
    'You quietly dropped poses from your teaching to feel safer',
    'You keep your full repertoire, with a supported version of every posture family',
  ],
  [
    'Referring out feels like turning a student away',
    'Referring out is the most professional sentence you say all week — and they come back with information',
  ],
  [
    'A teacher who hopes the room stays simple',
    'The teacher the studio sends its hardest room to',
  ],
];

export const inactionRows: Row[] = [
  [
    'You already spent $2,000–$3,000 on a 200-hour training (typical U.S. range)',
    'And it still did not cover the moment you actually dread',
  ],
  [
    'You pay around $42/month for liability insurance (Insureon average)',
    'For a risk you are managing with improvised sentences',
  ],
  [
    'You dropped poses from your teaching to feel safer',
    'Your repertoire shrinks every year, and your classes with it',
  ],
  [
    '"Listen to your body" as your standing answer',
    'The student is left alone at the exact moment they asked you for guidance',
  ],
  [
    'A studio interview asks how you handle injuries in group classes',
    'You answer from instinct instead of from a formula',
  ],
];

export const closeRows: Row[] = [
  ['Search your memory while twenty people wait', 'Open the Quick Card. Say the line. Teach the class.'],
  [
    'Hope more training eventually fixes the freeze',
    'Use the training you already have, at the moment it is needed',
  ],
  ['Deflect with "listen to your body"', 'Give a sensation to watch for and an option to take'],
];

export type FlowRow = {
  question: string;
  answer: string;
  output: string;
  tone: 'green' | 'amber' | 'red' | 'neutral';
};

export const flowchartRows: FlowRow[] = [
  {
    question: 'Q1. "Is this new, or something you have had for a while?"',
    answer: 'New, sudden or unexplained',
    output: 'STOP NOW — refer before loading',
    tone: 'red',
  },
  {
    question: '',
    answer: 'Ongoing and familiar to them',
    output: 'Continue to Q2',
    tone: 'neutral',
  },
  {
    question: 'Q2. "Has anyone treating it given you guidance to work with?"',
    answer: 'Yes, with guidance',
    output: 'GREEN — follow their guidance exactly',
    tone: 'green',
  },
  {
    question: '',
    answer: 'No guidance yet',
    output: 'TALK AFTER CLASS — conservative options today',
    tone: 'amber',
  },
  {
    question: 'Q3. "Does anything in class change it — or is it getting worse?"',
    answer: 'Worsening, radiating or numb',
    output: 'STOP NOW — refer out, in the words that keep the student',
    tone: 'red',
  },
  {
    question: '',
    answer: 'Predictable, and it settles',
    output: 'GREEN — offer the variation and teach',
    tone: 'green',
  },
];
